import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { ScheduleList } from '../ScheduleManagement/ScheduleList'

// Parent view for a single student's schedule (read-only)
const ParentSchedule = () => {
	const { user } = useAuth()
	const studentId = user?.studentId

	if (!studentId) {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body">
								<h5 className="card-title mb-3">Schedule</h5>
								<p className="mb-0">No active student is linked to this parent account.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<ScheduleList studentId={studentId} />
				</div>
			</div>
		</div>
	)
}

export { ParentSchedule }


